import { Component } from '@angular/core';

@Component({
  selector: 'ngx-pricing-widget',
  templateUrl: './pricing-widget.component.html',
  styleUrls: ['./pricing-widget.component.scss']
})
export class PricingWidgetComponent {
  constructor(){}
}
